/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_ViewInputs */

const vi_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem`)
};

/**

* @param {Action_ViewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const action_view = /** @type {((inputs?: Action_ViewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_ViewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_action_view(inputs)
});